import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import Sidebar from '../../common/Sidebar';
import Topbar from '../../common/Topbar';
import ProfileTopMenu from "./topmenu";
import { getLocalStorageVariables, getThemeSettingsVariables, handleTokenExpiry, isEmptyArray } from '../../common/Global/commonFunctions';
import { FilterCheckBox, PageSaveButton } from '../../common/Global/globalStyles.style';
import * as Constants from '../../common/Global/constants';
import AlertDialog from '../../common/AlertDialog';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();

class EmailNotification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAlertDialogInfo:false,  
            alertDialogMessageInfo:"",
            notificationList:[],
            componentDidMountFlag:false
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.getInitData();
    }

    handleCheckBoxClick = (e) => {
        const { name, checked } = e.target;
        let notificationList = [...this.state.notificationList];

        if(checked){
            // Add to notificationList if not already present
            if (!notificationList.includes(name)) {
                notificationList.push(name);
            }
            this.setState({
                notificationList
            })
        }else{
            // Remove from notificationList
            notificationList = notificationList.filter(item => item !== name);
            this.setState({
                notificationList
            })
        }
    }

    /******************** API CALLS **********************/
    getInitData = () => {
        this.setState({
            showLoader:true,
        });
        fetch(Constants.ProfileEmailNotification+"/"+userDetails.userId,
        {
            method: "POST",
            mode: 'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let notificationData = data.data;
                let notificationList = [...this.state.notificationList];
                if(!isEmptyArray(notificationData)){
                    notificationData.map(item => {
                        notificationList.push(item.notificationType);
                    })
                }
                this.setState({
                    notificationList:notificationList,
                    showLoader:false,
                    componentDidMountFlag:true,
                })
            }else{
                this.setState({
                    datalist:[],
                    showLoader:false,
                    componentDidMountFlag:true,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }

    saveSettings = () => {
        this.setState({
            showBtnLoader:true
        })

        fetch(Constants.ProfileEmailNotification,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                notificationList:JSON.stringify(this.state.notificationList)
            })
        })
        .then(response => { return response.json(); })
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showBtnLoader:false
                }, () => {
                    this.getInitData();
                    window.location.reload(false);
                })
            }
        });
    }

    /******************** API CALLS END HERE**********************/

    render() {
        return(
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />
                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <Topbar />
                                {
                                    this.state.showLoader &&
                                    <div class="loader"></div>
                                }
                                {this.state.componentDidMountFlag &&
                                    <div className="body-wrapper">
                                        <div className="profile-outer-layout">
                                            <div className="row custom-row">
                                                <div className="col-md-6 custom-col">
                                                    <div className="card-col">
                                                        <ProfileTopMenu
                                                            themeSettings={themeSettings}
                                                        />
                                                        {/* <h6></h6> */}
                                                        <FilterCheckBox themeSettings={themeSettings}
                                                        style={{marginLeft:0, marginTop:20}}>
                                                            <input
                                                                type="checkbox"
                                                                name={'other'}
                                                                id={'other'}
                                                                onChange={this.handleCheckBoxClick}
                                                                checked={this.state.notificationList.includes('other') ? true : false}
                                                            />
                                                            <label for={'other'}>Other</label>
                                                        </FilterCheckBox>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="common-close-save mt-4">
                                                <div className="common-close-save-col">
                                                    <PageSaveButton themeSettings={themeSettings} style={{marginLeft:10}}
                                                    onClick={this.saveSettings} type="button" className="common-save">
                                                        {this.state.showBtnLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                                                    </PageSaveButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type={Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={ Constants.ALERT_TYPE_OKAY_LABEL }
                            themeSettings={themeSettings}
                        />
                    </section>
                </main>
            </Router>
        )
    }
}
export default EmailNotification;